
















import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'NoWrapText',
  props: {
    text: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const isNoWrap = (chunk: string) => chunk.includes('-');

    const chunks = computed(() => {
      const text = props.text || '';

      if (!isNoWrap(text)) {
        return [text];
      }

      return text.split(',').map((item, index, arr) => (index === arr.length - 1 ? item.trim() : `${item.trim()},\u00A0`));
    });

    return {
      chunks,
      isNoWrap,
    };
  },
});
